import React, { useState } from "react";
import { invalidInput } from "../common/animations";
import { css } from "styled-components";
import { Mobile, Desktop, Tablet } from "../utils/media-queries";
import { Button } from "@material-ui/core";
import "./inline-user-input.component.css";

export const InlineUserInput = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Use the id prop as prefix, fallback to 'inline-input' if not provided
  const idPrefix = props.id || "inline-input";

  const inputStyle = {
    animation: props.invalid
      ? css`
          ${invalidInput} .2s ease
        `
      : "",
    // maxWidth: 400,
    marginLeft: 10,
    // minWidth:400,
    width: "100%",
    borderRadius: 4,
    boxSizing: "border-box",
    color: "#0E283FD9",
    fontSize: 16,
    opacity: props.disabled && !props.invalid ? ".5" : "1",
    outline: "none",
    padding: props.hasButton ? "16px 52px 16px 10px" : "16px 10px",
    WebkitAppearance: "none",
    borderWidth: 1,
    borderStyle: "solid",
    backgroundImage: 'url("/assets/images/send.svg"',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "98% 50%",
  };

  const validator = (value) => {
    if (props.validator) {
      const val = props.validator(value);
      if (val !== true) {
        setErrorMessage(val);
        return false;
      }
    }
    return true;
  };

  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      const validated = validator(inputValue);

      if (!inputValue.length || !validated) return false;
      const { triggerNextStep } = props;
      if (props.dispatchMessage) {
        await props.dispatchMessage(inputValue);
        triggerNextStep({ value: inputValue, sendUserMessage: true });
      } else {
        triggerNextStep({ value: inputValue, sendUserMessage: true });
      }
    }
  };

  const onValueChange = (event) => {
    setInputValue(event.target.value);
  };
  const onBlurSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const validated = validator(inputValue);

    if (!inputValue.length || !validated) return false;
    const { triggerNextStep } = props;
    if (props.dispatchMessage) {
      await props.dispatchMessage(inputValue);
      triggerNextStep({ value: inputValue, sendUserMessage: true });
    } else {
      triggerNextStep({ value: inputValue, sendUserMessage: true });
    }

    return false;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "95vw",
        backgroundColor: "#f5f5f5",
      }}
      id={`${idPrefix}-container`}
      data-testid={`${idPrefix}-container`}
    >
      <div
        style={{
          display: "flex",
          marginTop: 5,
          justifyContent: "space-between",
          columnGap: 8,
        }}
        id={`${idPrefix}-input-wrapper`}
        data-testid={`${idPrefix}-input-wrapper`}
      >
        <input
          className="inline-user-input-field"
          name={props.name || ""}
          type={props.type || "textarea"}
          maxLength={props.maxLength}
          value={inputValue}
          placeholder={props.placeholder}
          style={inputStyle}
          onKeyPress={handleKeyPress}
          onChange={onValueChange}
          onBlur={onBlurSubmit}
          id={`${idPrefix}-field`}
          data-testid={`${idPrefix}-field`}
        />

        {false && props.defaultInputMessage && (
          <Button
            onClick={(e) => {
              setInputValue(props.defaultInputMessage);
              onBlurSubmit(e);
            }}
            variant="text"
            style={{
              color: "#fff",
              textTransform: "none",
              backgroundColor: "#1565C0",
              borderRadius: 4,
              padding: " 8px 22px",

              boxShadow:
                "0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
            }}
            id={`${idPrefix}-default-button`}
            data-testid={`${idPrefix}-default-button`}
          >
            {props.defaultInputMessage}
          </Button>
        )}
      </div>
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 5,
        }}
        id={`${idPrefix}-info-row`}
        data-testid={`${idPrefix}-info-row`}
      >
        <em
          style={{ color: "red", textDecoration: "italic" }}
          id={`${idPrefix}-error-message`}
          data-testid={`${idPrefix}-error-message`}
        >
          {inputValue.length === props.maxLength
            ? "The max character limit has been reached. "
            : null}
          <br />
          {errorMessage}
        </em>
        {props.maxLength ? (
          <em
            style={{
              color: inputValue.length === props.maxLength ? "red" : "",
              textDecoration: "italic",
            }}
            id={`${idPrefix}-character-count`}
            data-testid={`${idPrefix}-character-count`}
          >
            {inputValue.length}/{props.maxLength}
          </em>
        ) : null}
      </span>
      <Desktop>
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: we don't need this now */}
        <div
          style={{
            width: 47,
            height: 38,
            backgroundColor: "transparent",
            position: "relative",
            float: "right",
            marginLeft: "75%",
            zIndex: 10000000,
            top: -63,
          }}
          onClick={onBlurSubmit}
          id={`${idPrefix}-submit-desktop`}
          data-testid={`${idPrefix}-submit-desktop`}
        />
      </Desktop>
      <Mobile>
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: we don't need this now */}
        <div
          style={{
            width: 47,
            height: 38,
            backgroundColor: "transparent",
            position: "relative",
            float: "right",
            marginLeft: "88%",
            zIndex: 10000000,
            top: -63,
          }}
          onClick={onBlurSubmit}
          id={`${idPrefix}-submit-mobile`}
          data-testid={`${idPrefix}-submit-mobile`}
        />
      </Mobile>

      <Tablet>
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: we don't need this now */}
        <div
          style={{
            width: 47,
            height: 38,
            backgroundColor: "transparent",
            position: "relative",
            float: "right",
            marginLeft: "70%",
            zIndex: 10000000,
            top: -63,
          }}
          onClick={onBlurSubmit}
          id={`${idPrefix}-submit-tablet`}
          data-testid={`${idPrefix}-submit-tablet`}
        />
      </Tablet>
    </div>
  );
};
